<template><section :id="anchor(props.name)" :data-name="props.name" ref="root" class="sect">
<slot>OPart {{props.name}}</slot>
</section></template>

<style lang="scss">
    .sect {overflow: hidden; scroll-margin-top: 70px; }
</style>

<script setup>
import {ref, onMounted, onBeforeUnmount} from 'vue'
import { anchor  } from  './NAV.js'

const root = ref(null)


const props = defineProps({
    name: {
        type: String,
    },
})
</script>
